<template>
  <div class="pc-newsList">
    <BreadCrumb :data="breadcrumb" :title="'新闻列表管理'" />
    <StatisticalPanel
      :whichModule="'news'"
      :data="overallData"
    ></StatisticalPanel>
    <ModuleClassfication
      :title="topics"
      class="pc-news-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <NewsTable />
  </div>
</template>


<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel";
import ModuleClassfication from "../../componentSet/ModuleClassfication";
import NewsTable from "./components/NewsTable";
import {
  getNewsCount_Api,
  getNewsTopics_Api,
  addNewsTopics_Api,
  updateNewsTopics_Api,
  deleteNewsTopics_Api,
} from "../../../apis/news.api";
export default {
  components: {
    BreadCrumb,
    StatisticalPanel,
    NewsTable,
    ModuleClassfication,
  },
  data() {
    return {
      overallData: {
        title: "新闻数据",
        count: [
          { name: "新闻", count: null },
          { name: "事件", count: null },
        ],
      },
      topics: { module: "新闻", class: [{ name: "Topics", subTitles: [] }] },
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "新闻列表", link: "/admin/news" },
      ];
    },
  },
  mounted() {
    getNewsCount_Api().then((res) => {
      this.$set(this.overallData.count[0], "count", res.data.news_count);
      this.$set(this.overallData.count[1], "count", res.data.events_count);
    });
    this.getNewsTopic();
  },
  methods: {
    updateTopic(topic, callback) {
      if (topic.type == "Topics") {
        updateNewsTopics_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          topic_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.getNewsTopic();
        });
      }
    },
    addTopic(topic, callback) {
      if (topic.type == "Topics") {
        addNewsTopics_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.getNewsTopic();
        });
      }
    },
    deleteTopic(topic, callback) {
      if (topic.type == "Topics") {
        deleteNewsTopics_Api({ topic_id: topic.id }).then(() => {
          callback();
          this.getNewsTopic();
        });
      }
    },
    getNewsTopic() {
      getNewsTopics_Api().then((res) => {
        this.$set(this.topics.class[0], "subTitles", res.data);
        console.log(this.topics);
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/admin/news/News.vue